const MESSAGES = {
    damaged:  { type: 'warning', title: 'Matériel endommagé — À benner',   subtitle: 'Ce matériel doit être mis directement à la benne pour recyclage.' },
    normal:   { type: 'success', title: 'Matériel normal enregistré',       subtitle: 'Un 2ème scan sera nécessaire pour connaître le traitement à réaliser.' },
};

export function getCounterMessage(isDamaged) {
    if (isDamaged === null) return null;
    return isDamaged ? MESSAGES.damaged : MESSAGES.normal;
}

export function getTypeFirstScan(isDamaged) {
    return isDamaged ? 'endommage' : 'normal';
}
